import { z } from "zod";
import { customErrorMap, myPreProcess } from "../shared/validation/zod";

z.setErrorMap(customErrorMap);

export const DocumentCustomDataSchema = z.object({
  id: z.number(),
  business_id: z.number(),
  document_id: z.number(),
  field_index: z.number(),
  field_id: z.number().nullable(),

  created_at: z.string(),
  updated_at: z.string(),

  field_value: z.string().nullish(),
});

export const DocumentCustomDataFormSchema = z.object({
  id: z.number().optional(),
  business_id: z.number().optional(),
  document_id: z.number().optional(),
  field_id: z.number().nullish(),

  created_at: z.string().optional(),
  updated_at: z.string().optional(),

  field_index: z.number(),
  field_value: z.preprocess((val) => myPreProcess(val), z.string().nullish()),
});

export type DocumentCustomData = z.infer<typeof DocumentCustomDataSchema>;
export type DocumentCustomDataForm = z.infer<typeof DocumentCustomDataFormSchema>;

